<template>
  <div class="about">
    <div class="about-header">
      <div class="profile-container">
        <img src="../assets/images/KSC09560.webp" alt="Photographer Profile" class="profile-image">
      </div>
      <div class="intro-text">
        <h1>Krilin Schmid</h1>
        <h2>Informatiker Betriebsinformatik EFZ und Hobby Foto- und Videograf</h2>
        <p>Capturing life's precious moments through the lens of creativity and passion.</p>
      </div>
    </div>

    <div class="tabs">
      <div class="tab-options">
        <button
          :class="{ active: selectedCategory === 'business' }"
          @click="switchTab('business')"
        >
          Beruflich
        </button>
        <button
          :class="{ active: selectedCategory === 'private' }"
          @click="switchTab('private')"
        >
          Privat & Hobbys
        </button>
        <div class="tab-underline" :class="selectedCategory"></div>
      </div>
    </div>

    <div class="timeline">
      <div
        v-for="(experience, index) in filteredTimeline"
        :key="index"
        class="timeline-item"
        ref="timelineItems"
      >
        <div class="timeline-content">

          <!-- Label für Oberkategorie -->
          <div v-if="experience.subItems" class="category-label">Swisscom Lehre</div>

          <h3>{{ experience.title }}</h3>
          <p class="date">{{ experience.date }}</p>
          <p class="description">{{ experience.description }}</p>

          <!-- SubItems anzeigen -->
          <div v-if="experience.subItems">
            <div
              v-for="(sub, subIndex) in experience.subItems"
              :key="subIndex"
              class="sub-timeline"
            >
              <h4>{{ sub.title }}</h4>
              <ul class="achievements-list">
                <li v-for="(ach, i) in sub.achievements" :key="i">• {{ ach }}</li>
              </ul>
            </div>
          </div>

          <!-- Einzelne achievements ohne SubItems -->
          <button
            v-else-if="experience.achievements"
            class="dropdown-toggle"
            @click="toggleDropdown(index)"
          >
            {{ expandedItems[index] ? 'Weniger anzeigen ▲' : 'Mehr anzeigen ▼' }}
          </button>

          <transition name="fade">
            <ul v-if="expandedItems[index] && !experience.subItems" class="achievements-list">
              <li v-for="(ach, i) in experience.achievements" :key="i">
                • {{ ach }}
              </li>
            </ul>
          </transition>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      selectedCategory: 'business',
      expandedItems: {},
      timeline: [
        {
          category: 'business',
          date: 'Juli 2025 - März 2026',
          title: 'Zivildienst IT in der Stiftung Lerchenbühl',
          description: 'Damit ich möglichst schnell wieder komplett auf meinen beruflichen Werdegang konzentrieren kann, habe ich direkt im Anschluss zu meinem ersten Zivildienst-Einsatz einen weiteren durchgeführt.',
          achievements: [
            'Unterstützung der Lehrperson im Klassenzimmer und in der Berufsvorbereitung',
            '1st und 2nd Level Support der Mitarbeiter/innen',
            'Projektübernahme von diversen IT-Projekten'
          ]
        },
        {
          category: 'business',
          date: 'Januar 2025 - Juni 2025',
          title: 'Zivildienst an den Schulen der Gemeinde Lützelflüh',
          description: 'Anstelle des Militärdienstes bin ich in der Gemeinde Lützelflüh als Zivildienstleistender tätig. Hier erledigte ich hauptsächlich folgende Aufgaben:',
          achievements: [
            'Unterstützung der Lehrperson im Klassenzimmer',
            'Begleitperson in der Tagesstruktur',
            'Administrative Aufgaben in der Schule'
          ]
        },
        // Weitere berufliche Stationen, die nicht Teil der Lehre sind
        {
          category: 'business',
          date: 'August 2023 - Dezember 2024',
          title: 'Marketingassistent @ Interhockey',
          description: 'Während meiner Zeit bei der Interhockey war ich zuständig für das Merchandising-Management für führende Eishockeyvereine sowie für kleinere Vereine und Unternehmen. Zudem war ich für die Webseiten und Webshops der Interhockey AG verantwortlich.',
          achievements: [
            'Sortimentmanagement für Merchandising des SC Bern und HC Ajoie in direkter Zusammenarbeit mit den Vereinen.',
            'Leitung von Merchandisingprojekten für eine breite Palette von Sportclubs und Unternehmen.',
            'Pflege und Aktualisierung der Webseiten und Webshops der Interhockey AG.',
            'Wartung des Webshops für den SC Bern und HC Ajoie.',
            'Inbetriebnahme neuer Webshops für den SC Bern sowie für die Interhockey AG.',
            'Erstellung vielfältiger Anzeigen und Werbematerialien (Physisch/Digital) der Interhockey AG.',
            'Gestaltung und Verwaltung von Newslettern und Social Media Beiträgen für die Interhockey AG.',
            'Erstellung von Produktelayouts.'
          ]
        },
        {
          category: 'business',
          date: 'Januar 2023 - Juli 2023',
          title: 'Auftragsbearbeitung @ Interhockey',
          description: 'Mitarbeit in der Auftragsbearbeitung. Meine Aufgaben waren unter anderem:',
          achievements: [
            'Kontrolle der Kassenabschlüsse von allen Interhockey Shops.',
            'Erfassung und Bearbeitung von Kundenbestellungen über Mail oder Telefon.',
            'Erfassung und Wartung von Kundenkonten.',
            'Unterstützung in der Wartung des Webshops.',
            'Unterstützung bei internen IT-Problemen.'
          ]
        },
        {
          category: 'business',
          date: 'August 2022 - Dezember 2022',
          title: 'Berufliche Auszeit',
          description: 'Im August 2022 startete ich meine Reise, zuerst verbrachte ich rund drei Wochen auf der Insel Oahu in Hawaii und konnte mir einen Kindheitstraum erfüllen. Anschliessend reiste ich nach New York um dort mit meinem Bruder einiges an Zeit zu verbringen. In diesen 3 1/2 Monaten konnte ich Utica, Old Forge, Oceanside und vorallem New York und Newark erforschen.',
          achievements: []
        },
             // Swisscom-Lehre als Oberkategorie
        {
          category: 'business',
          date: 'August 2018 - Juli 2022',
          title: 'Lehre Informatiker Betriebsinformatik EFZ @ Swisscom',
          description: 'Während meiner Lehre durchlief ich verschiedene Abteilungen bei der Swisscom. Alle Punkte unten gehören zu dieser Ausbildung.',
          subItems: [
            {
              title: 'Fullstack Developer @ AppsTeam',
              achievements: [
                'Frontend (Vue.js) & Backend (TypeScript) Weiterentwicklung',
                'Datenverwaltung mit TypeOrm/MySQL',
                'Onboarding von Telekommunikationsservices'
              ]
            },
            {
              title: 'Video Surveillance @ Swisscom Broadcast',
              achievements: [
                'Server-Staging',
                'Konfiguration und Wartung von Videokameras'
              ]
            },
            {
              title: 'Mac Engineering Service @ Swisscom',
              achievements: [
                'Support von Mac Benutzern',
                'Automatisierungsskripts mit Bash',
                'Managed Mac Services weiterentwickelt',
                'Leitung der Lernenden im Team'
              ]
            },
            {
              title: 'Frontend Developer @ TalentSquad',
              achievements: [
                'Frontendentwicklung mit Angular',
                'Erstellung von GIT-Guidelines'
              ]
            },
            {
              title: 'Frontend Developer @ Traffy',
              achievements: [
                'Frontendentwicklung mit Vue.js',
                'Erste Erfahrungen mit GIT gesammelt',
                'SCRUM kennengelernt'
              ]
            },
            {
              title: 'Telefonsupport @ Service Desk INI',
              achievements: [
                'Support von Swisscom Mitarbeitern am Telefon',
                'Problemanalyse und Problemlösung',
                'Support der Swisscom Tools',
                'Vergabe von Accountberechtigungen'
              ]
            },
          ]
        },
        {
          category: 'private',
          date: 'Seit 2022',
          title: 'Hobby-Fotograf & -Videograf',
          description: 'In meiner Freizeit widme ich mich mit großer Leidenschaft der Fotografie und Videografie – insbesondere in den Bereichen Natur-, Street- und Sportfotografie.',
          achievements: [
            'Aufbau einer eigenen professionellen Kameraausrüstung',
            'Erfahrung im Umgang mit Adobe Lightroom & DaVinci Resolve',
            'Aktive Präsentation meiner Arbeiten über ein eigenes Instagram-Profil',
            'Sportfotograf an den Heimspielen des SC Bern'
          ]
        },
        {
          category: 'private',
          date: 'Seit 2017',
          title: 'Aktivmitglied im Turnverein Bärau',
          description: 'Als langjähriges Mitglied des Turnvereins Bärau bin ich vielseitig sportlich aktiv – mit Fokus auf Leichtathletik (Sommer) und Unihockey (Winter). Bei Bedarf unterstütze ich zudem das Korbballteam.',
          achievements: [
            'Co-Leitung des Unihockeyteams (Trainingsorganisation, Mitgliedergewinnung)',
            'Verantwortlich für die Pflege der Vereinswebseite sowie des Instagram-Kanals'
          ]
        },
        {
          category: 'private',
          date: 'Seit 2010',
          title: 'Leidenschaftlicher Eishockeyspieler',
          description: 'Seit meiner Kindheit begleitet mich Eishockey als Sport und Passion – vom ambitionierten Nachwuchsspieler bis hin zum heutigen Plauschhockey.',
          achievements: [
            'Juniorenzeit bei den SCL Young Tigers und den HC Huskys Oberlangenegg',
            'Heute aktiv als Plauschhockeyspieler im Amateurbereich'
          ]
        },
        {
          category: 'private',
          date: 'Seit Juni 2023',
          title: 'Jugendsportleiter 6.–9. Klasse',
          description: 'Als engagiertes Aktivmitglied des Turnvereins Bärau unterstütze ich die sportliche und persönliche Entwicklung unserer Jugendlichen.',
          achievements: [
            'Leitung und Mitgestaltung von wöchentlichen Trainingseinheiten',
            'Begleitung und Betreuung bei Wettkämpfen und Vereinsanlässen'
          ]
        }
      ]
    };
  },
  computed: {
    filteredTimeline() {
      return this.timeline.filter(
        (e) => e.category === this.selectedCategory
      );
    },
  },
  mounted() {
    this.initializeObservers();
  },
  methods: {
    switchTab(category) {
      if (this.selectedCategory !== category) {
        this.selectedCategory = category;
        this.$nextTick(() => {
          this.initExpandedItems();
          this.initializeObservers();
        });
      }
    },
    initExpandedItems() {
      this.expandedItems = {};
      this.filteredTimeline.forEach((_, index) => {
        this.expandedItems[index] = false;
      });
    },
    toggleDropdown(index) {
      this.expandedItems[index] = !this.expandedItems[index];
    },
    initializeObservers() {
      const items = this.$refs.timelineItems || [];
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add('visible');
            }
          });
        },
        { threshold: 0.1 }
      );

      items.forEach((item) => {
        item.classList.remove('visible');
        observer.observe(item);
      });
    },
  },
};
</script>

<style scoped>
.about {
  min-height: calc(100vh - 80px);
  padding: 10rem 2rem 3rem;
  font-family: 'Inter', sans-serif; /* moderne, gut lesbare Schrift */
  line-height: 1.65;
}

/* Header */
.about-header {
  max-width: 1100px;
  margin: 0 auto 5rem;
  display: flex;
  align-items: center;
  gap: 3rem;
}

.profile-image {
  width: 260px;
  height: 260px;
  object-fit: cover;
  border-radius: 50%;
  border: 4px solid var(--accent);
  box-shadow: 0 6px 16px rgba(0,0,0,0.25);
}

.intro-text h1 {
  font-size: 2.5rem;
  margin-bottom: 0.6rem;
  color: var(--accent);
}

.intro-text h2 {
  font-size: 1.3rem;
  color: var(--text-primary);
  margin-bottom: 1rem;
  font-weight: 500;
}

.intro-text p {
  font-size: 1.05rem;
  color: var(--text-secondary, #aaa);
  max-width: 600px;
}

/* Tabs */
.tabs {
  display: flex;
  justify-content: center;
  margin: 2.5rem 0;
}

.tab-options {
  display: flex;
  background-color: #1c1c1c;
  border-radius: 10px;
  overflow: hidden;
  border: 2px solid var(--accent);
  position: relative;
}

.tab-options button {
  flex: 1;
  padding: 0.9rem 1.8rem;
  background: none;
  color: white;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  border: none;
  position: relative;
  z-index: 2;
  transition: all 0.3s ease;
}

.tab-options button.active {
  color: var(--accent);
}

.tab-options button:hover {
  transform: translateY(-2px);
}

.tab-underline {
  position: absolute;
  bottom: 0;
  width: 50%;
  height: 3px;
  background-color: var(--accent);
  z-index: 1;
  transition: left 0.3s ease;
}
.tab-underline.business { left: 0; }
.tab-underline.private { left: 50%; }

/* Timeline */
.timeline {
  max-width: 750px;
  margin: 0 auto;
  padding: 1rem;
}

.timeline-item {
  margin-bottom: 2.5rem;
  opacity: 0;
  transform: translateY(40px);
  transition: opacity 0.6s ease, transform 0.6s ease;
}

.timeline-item.visible {
  opacity: 1;
  transform: translateY(0);
}

.timeline-content {
  background-color: #2a2a2a;
  padding: 1.5rem 1.8rem;
  border-left: 4px solid var(--accent);
  border-radius: 10px;
  color: white;
  box-shadow: 0 4px 12px rgba(0,0,0,0.25);
}

.category-label {
  display: inline-block;
  background-color: var(--accent);
  color: #111;
  font-size: 0.8rem;
  font-weight: bold;
  padding: 0.25rem 0.7rem;
  border-radius: 4px;
  margin-bottom: 0.7rem;
}

.timeline-content h3 {
  margin: 0 0 0.4rem 0;
  font-size: 1.3rem;
}

.date {
  font-size: 0.9rem;
  color: #bbb;
  margin-bottom: 0.8rem;
}

.description {
  font-size: 1.05rem;
  margin-bottom: 0.8rem;
  color: var(--text-secondary, #ccc);
}

.dropdown-toggle {
  background: none;
  border: none;
  color: var(--accent);
  cursor: pointer;
  margin-top: 0.8rem;
  font-size: 0.95rem;
  font-weight: 500;
  text-align: left;
  padding: 0;
}

.achievements-list {
  margin-top: 0.7rem;
  padding-left: 1.4rem;
  list-style: none;
}

.achievements-list li {
  margin-bottom: 0.4rem;
  font-size: 0.95rem;
  color: var(--text-primary);
}

.sub-timeline {
  margin-top: 1rem;
  margin-left: 1rem;
  border-left: 3px solid var(--accent);
  padding-left: 1rem;
}

.sub-timeline h4 {
  font-size: 1.1rem;
  margin-bottom: 0.3rem;
  color: var(--accent);
  font-weight: 600;
}

.sub-timeline .achievements-list li {
  font-size: 0.92rem;
  margin-bottom: 0.25rem;
  color: var(--text-secondary, #ccc);
}

/* Animations */
.fade-enter-active,
.fade-leave-active {
  transition: all 0.3s ease;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
  max-height: 0;
  overflow: hidden;
}

/* Responsive */
@media only screen and (max-width: 768px) {
  .about-header {
    flex-direction: column;
    gap: 2rem;
    text-align: center;
  }
  .profile-image {
    width: 220px;
    height: 220px;
  }
  .intro-text h1 {
    font-size: 2rem;
  }
}

</style>
